module.exports = __webpack_public_path__ + "static/media/huaming.39fdd628.jpg";